import React, {Component} from 'react';

import LangContext from "../../providers/LangContext";

let osmb = null;

class ZonneGrensContainer extends Component {

    static contextType = LangContext;

    constructor(props) {
        super(props);

        this.state = {
            now: new Date().toISOString(),
            startDate: new Date(),
            lat: null,
            lng: null,
            tilt: 45,
            rotation: 0,
            didRender: false,
            dateRangeLabel: '',
            timeRangeLabel: ''
        };

        this.onDateChange = this.onDateChange.bind(this);
        this.onTimeChange = this.onTimeChange.bind(this);
        this.getDate = this.getDate.bind(this);
        this.getDayOfYear = this.getDayOfYear.bind(this);
        this.setTilt = this.setTilt.bind(this);
        this.setRotation = this.setRotation.bind(this);
        this.scriptLoaded = this.scriptLoaded.bind(this);

        this.pad = this.pad.bind(this);
    }

    componentDidCatch(error, errorInfo) {
        return false;
    }

    componentDidMount() {
        const script = document.createElement("script");
        script.src = "https://cdn.osmbuildings.org/4.0.7/OSMBuildings.js";
        script.async = true;
        script.onload = () => this.scriptLoaded();
        document.body.appendChild(script);

    }

    componentWillUnmount() {
        osmb = null;
    }

    scriptLoaded() {

        if (!this.props.latLng || undefined === window.OSMBuildings) {
            return;
        }

        const center = this.props.latLng.split(',');

        this.setState({
            lat: parseFloat(center[0]),
            lng: parseFloat(center[1]),
            tilt: 45,
        });

        osmb = new OSMBuildings({
            container: 'map',
            position: {latitude: parseFloat(center[0]), longitude: parseFloat(center[1])},
            attribution: `${this.props.theme === 'era' ? '' : '&copy; <a href="https://gogary.com">Gary</a> | '}&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>`,
            zoom: 19,
            maxZoom: 19,
            minZoom: 16,
            maxNativeZoom: 19,
        });

        osmb.addGeoJSONTiles('https://{s}-data.onegeo.co/maps/tiles/{z}/{x}/{y}.json?token=hswphomeshow.nhdqxpxn');
        osmb.addMapTiles('https://a.tile.openstreetmap.org/{z}/{x}/{y}.png');

        let marker = (this.props.theme === 'era'
        ?
                osmb.addOBJ(window.location.origin + '/images/fvq9dg5rhive.obj',
                    {
                        latitude: parseFloat(center[0]),
                        longitude: parseFloat(center[1]),
                        altitude: 20,
                    },
                    {
                        id: `marker-1`,
                        scale: 55,
                        altitude: this.props.height,
                        rotation: 0,
                        color: '#cf112b',
                    },
                )
                :
                osmb.addOBJ(window.location.origin + '/images/Logo%20Home%20Thicker%20Triangulated.obj',
                    {
                        latitude: parseFloat(center[0]),
                        longitude: parseFloat(center[1]),
                        altitude: 30,
                    },
                    {
                        id: `marker-1`,
                        scale: 0.2,
                        altitude: this.props.height,
                        rotation: 0,
                        color: '#f26722',
                    },
                )
        );

        osmb.setTilt(this.state.tilt);
        this.changeDate()
    }

    setTilt(val) {
        osmb.setTilt(val);
        this.setState({tilt: val});
    }

    setRotation(val) {
        osmb.setRotation(val);
        this.setState({rotation: val});
    }

    getDate() {
        return new Date(this.state.now);
    }

    changeDate() {
        let d = this.getDate();
        let Y = d.getFullYear(),
            M = d.getMonth(),
            D = d.getDate(),
            h = d.getHours(),
            m = 0;


        this.setState({
            timeRangeLabel: this.pad(h) + ':' + this.pad(m),
            dateRangeLabel: this.pad(D) + '-' + this.pad(M + 1) + '-' + Y
        });
        osmb.setDate(new Date(Y, M, D, h, m));

    }

    onTimeChange({target}) {

        let newNow = new Date(this.state.now);
        newNow.setHours(target.value);
        newNow.setMinutes(0);
        this.setState({now: newNow.toISOString()}, () => this.changeDate());
    }

    onDateChange({target}) {
        let newNow = new Date(this.state.now);
        newNow.setMonth(0);
        newNow.setDate(target.value);
        this.setState({now: newNow.toISOString()}, () => this.changeDate());
    }

    getDayOfYear(date) {
        let start = new Date(date.getFullYear(), 0, 0);
        let diff = (date - start) + ((start.getTimezoneOffset() - date.getTimezoneOffset()) * 60 * 1000);
        let oneDay = 1000 * 60 * 60 * 24;
        let day = Math.floor(diff / oneDay);
        return day;
    }

    pad(v) {
        return (v < 10 ? '0' : '') + v;
    }

    render() {

        let lang = this.context.lang;
        return (
            <div style={{position: 'relative'}}>
                <div id="map"/>

                <div className="time-control">
                    <div className="row">
                        <div className="col-3 mt-1 text-right">
                            <label htmlFor="date">{lang.get('sites.date')}:</label>
                        </div>
                        <div className="col-6">
                            <input onChange={this.onDateChange}
                                   defaultValue={this.getDayOfYear(this.state.startDate)} id="date" type="range" min="1"
                                   max="365" step="1"/>
                        </div>
                        <div className="col-3 mt-1 p-0 p-md-2">
                            <label>{this.state.dateRangeLabel}</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3 mt-1 text-right">
                            <label htmlFor="time">{lang.get('sites.time')}:</label>
                        </div>
                        <div className="col-6">
                            <input onChange={this.onTimeChange}
                                   defaultValue={this.state.startDate.getHours()} id="time" type="range" min="0"
                                   max="23"
                                   step="1"/>
                        </div>
                        <div className="col-3 mt-1 text-left p-0 p-md-2">
                            <label>{this.state.timeRangeLabel}</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3 mt-1 text-right">
                            <label
                                htmlFor="tilt">{lang.get('sites.viewing_angle')}:</label>
                        </div>
                        <div className="col-6">
                            <input id="tilt" type="range" onChange={(e) => {
                                this.setTilt(e.target.value)
                            }} defaultValue={this.state.tilt} min="0" max="45" step="1"/>
                        </div>
                        <div className="col-3 mt-1 text-left p-0 p-md-2">
                            <label>{this.state.tilt}°</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3 mt-1 text-right">
                            <label
                                htmlFor="tilt">{lang.get('sites.rotation')}:</label>
                        </div>
                        <div className="col-6">
                            <input id="rotation" type="range" onChange={(e) => {
                                this.setRotation(e.target.value)
                            }} defaultValue={this.state.rotation} min="-180" max="180" step="1"/>
                        </div>
                        <div className="col-3 mt-1 text-left p-0 p-md-2">
                            <label>{this.state.rotation}°</label>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default ZonneGrensContainer;
